import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { ArrayStorageRepository } from "./abstract/array.storage.repository";

export interface ClientSchemasRecord {
  dlClientID: string;
  schemas: { [schemaName: string]: any };
}

@Injectable({
  providedIn: "root",
})
export class ClientSchemasRepository extends ArrayStorageRepository<ClientSchemasRecord> {
  constructor(storage: Storage) {
    super(storage, "clientSchemas", "dlClientID");
  }

  public setClientSchemas(
    dlClientID: string,
    schemas: { [schemaName: string]: any },
  ): Promise<ClientSchemasRecord> {
    return this.saveRecord("dlClientID", { dlClientID, schemas });
  }

  public async getClientSchemas(
    dlClientID: string,
  ): Promise<{ [schemaName: string]: any } | undefined> {
    const record = await this.getById(dlClientID);
    return record?.schemas;
  }

  public removeClientSchemas(
    dlClientID: string,
  ): Promise<ClientSchemasRecord[]> {
    return this.remove("dlClientID", dlClientID);
  }
}
